var Aneox;
(function(Aneox) {
    (function(Controllers) {
        'use strict';

        var Company = (function() {

            var self;
            var activeAside;
            var animState;
            var windowHeight;

            function Company(animations) {
                self = this;
                self.timeline = animations.timeline;
                
                
            }

            Company.prototype.enter = function() {
                activeAside = '#company-aside';
                
                $('#company-export .pointer').empty();
                
                self.snap = Snap('#company-export .pointer');
                Snap.load((rootPath || '') + 'assets/societe/mapmonde.svg', function(svg) {
                    self.snap.append(svg);
                });
                 

                if(Aneox.Data.Config.runtime.isTouchDevice){
                    $("#company-kpis .play").css({display: 'block'});
                    
                    
                    $("#video-selection").on('play', function(event){
                        $("#company-kpis .play:eq(1)").css({display: 'block'});
                    });
                    
                    
                    $("#video-tresors").on('play',function(event){
                        $("#company-kpis .play:eq(0)").css({display: 'block'});
                    });
                }
                
                
                self.timeline.call(function() {
                    animState = {};
                    $('#company-kpis a').removeClass('alt');
                });

                //$('.losange').hide();
                
                self.timeline.set('#company', { display: 'block', opacity: 0 });
                self.timeline.set('#company-aside', { display: 'block', opacity: 0 });
                
                self.timeline.call(self.handleWindowResize.bind(self));
                self.timeline.call(function() { $('html, body').scrollTop(0); });

                self.timeline.to('#company', 0.5, { opacity: 1 });
                self.timeline.to('#company-aside', 0.5, { opacity: 1 }, '-=0.5');
                
                self.timeline.call(function(){
                    
                        var tl = new TimelineMax({repeatDelay: 0.5, repeat: -1});
                        $("#company-export .losange").each(function(index, item){
                           tl.to(item, 1, { scale: 1.5, transformOrigin: '50% 50%', force3D: true },'-=1');
                        });
                });

                if (Aneox.Data.Config.runtime.supportsScrollEvents) {
                    self.timeline.set('#company-mast-plot-line', { opacity: 0 }, 0);
                    self.timeline.set('#company-plot-line', { display: 'none' }, 0);
                    self.timeline.set('#company .mast-next g', { opacity: 1 }, 0);

                    self.timeline.set('#company .content-block:eq(0)', { opacity: 0 }, 0);
                    self.timeline.set('#company .content-block:eq(3)', { opacity: 0 }, 0);
                    self.timeline.set('#company .content-block:eq(4)', { opacity: 0 }, 0);

                    self.timeline.set('#company .mask', { display: 'block', top: 0 }, 0);
                    self.timeline.set('#company-about', { opacity: 0 }, 0);

                    self.timeline.to('#company-mast .mask', 1, { top: '100%' });
                    self.timeline.set('#company-about', { y: 50 });
                    self.timeline.to('#company-about', 1, { opacity: 1, y: 0 });
                    self.timeline.to('#company-mast-plot-line', 0.5, { opacity: 1 }, '-=0.5');
                    //self.timeline.to('#company-plot-line', 0.5, { opacity: 1 }, '-=0.5');
                }
                
               
            };

            Company.prototype.leave = function(callback) {
                self.timeline.call(function() {
                    TweenMax.killChildTweensOf('#company');
                });

                self.timeline.to('#company', 0.5, { display: 'none', opacity: 0 });
                self.timeline.to(activeAside, 0.5, { display: 'none', opacity: 0 }, '-=0.5');

                if (callback) self.timeline.call(callback);
            };

            Company.prototype.handleWindowResize = function() {
                windowHeight = $(window).height();

                var plotLineTop = $('#company-about p').offset().top + $('#company-about p').innerHeight() - 30;
                var plotLineBottom = $('#company-export h2').offset().top - 50;
                $('#company-plot-line').css('top', plotLineTop + 'px');
                $('#company-plot-line').css('height', (plotLineBottom - plotLineTop) + 'px');
            };

            Company.prototype.toggleDetails = function(section) {
                var newAside = '#company-aside-' + section;
                if (activeAside === newAside) return self.hideDetails();

                self.timeline.call(function() {
                    $('#company-kpis a').removeClass('alt');
                    $('#company-kpis a[data-aside="' + section + '"]').addClass('alt');
                });
                self.timeline.to(activeAside, 0.5, { display: 'none', opacity: 0 });

                activeAside = newAside;

                self.timeline.set(activeAside, { display: 'block', opacity: 0 }, '-=0.5');
                self.timeline.set(activeAside + ' .button-mask', { display: 'block', x: '0%' }, '-=0.5');
                self.timeline.to(activeAside, 0.5, { opacity: 1 }, '-=0.5');
                self.timeline.to(activeAside + ' .button-mask', 0.5, { x: '100%', display: 'none' });
            };

            Company.prototype.hideDetails = function() {
                var newAside = '#company-aside';
                if (activeAside === newAside) return;

                self.timeline.call(function() {
                    $('#company-kpis a').removeClass('alt');
                });
                self.timeline.to(activeAside, 0.5, { display: 'none', opacity: 0 });

                activeAside = newAside;

                self.timeline.set(activeAside, { display: 'block', opacity: 0 }, '-=0.5');
                self.timeline.to(activeAside, 0.5, { opacity: 1 }, '-=0.5');
            };
            
             Company.prototype.startVideo = function(id){
              $('#company-kpis video:eq('+ id +')')[0].play();
                $('#company-kpis .play:eq('+ id +')').css({display: 'none'});
             };

            Company.prototype.handleScroll = function(event) {
                if (!Aneox.Data.Config.runtime.supportsScrollEvents) return;
                if (!animState) return;

                //console.log($('#company-about')[0].getBoundingClientRect().top +'+'+ $('#company-about').innerHeight());

                if (!animState.plotLine && ($('#company-about')[0].getBoundingClientRect().top + $('#company-about').innerHeight()) < windowHeight * 0.5) {
                    var height = $('#company-plot-line').height();
                    TweenMax.set('#company-plot-line', { display: 'block', height: 0 });
                    TweenMax.to('#company-plot-line', 3, { height: height });
                    animState.plotLine = true;
                }


                if (!animState.selection && $('#company-kpis .content-block:eq(0)')[0].getBoundingClientRect().top < windowHeight * 0.5) {
                    TweenMax.to('#company-kpis .content-block:eq(1) .mask', 1, { top: '100%', onComplete: function(){
                        if(!Aneox.Data.Config.runtime.isTouchDevice) $('#company-kpis video:eq(0)')[0].play();
                    }});
                    TweenMax.to('#company-kpis .content-block:eq(0)', 1, { opacity: 1, delay: 0.5});
                    animState.selection = true;
                }

                if (!animState.family && $('#company-kpis .content-block:eq(2)')[0].getBoundingClientRect().top < windowHeight * 0.5) {
                    TweenMax.to('#company-kpis .content-block:eq(2) .mask', 1, { top: '100%' });
                    TweenMax.to('#company-kpis .content-block:eq(3)', 1, { opacity: 1, delay: 0.5 });
                    animState.family = true;
                }

                if (!animState.stocks && $('#company-kpis .content-block:eq(5)')[0].getBoundingClientRect().top < windowHeight * 0.5) {
                    TweenMax.to('#company-kpis .content-block:eq(5) .mask', 1, { top: '100%', onComplete: function(){
                        if(!Aneox.Data.Config.runtime.isTouchDevice) $('#company-kpis video:eq(1)')[0].play();
                    }});
                    TweenMax.to('#company-kpis .content-block:eq(4)', 1, { opacity: 1, delay: 0.5 });
                    animState.stocks = true;
                }
            };

            return Company;
        })();

        Controllers.Company = Company;
    })(Aneox.Controllers || (Aneox.Controllers = {}));
})(Aneox || (Aneox = {}));